export default __webpack_public_path__ + "static/media/Punto_12_Finocchietti_ITA_Def.b1045dd1.aac";